<template>
	<div class="popular-artists-container">
		<div class="menuBox">
			<div class="naviBox">
				<div class="naviItem" :class="timeWhere == item.value ? 'active' : 'normal'"
					v-for="(item,index) in naviData" :key="index" @click="changeTimeWhere(item)">
					{{item.title}}
				</div>
			</div>
		</div>
		<div class="activityList">
			<div class="activity" v-for="(item,index) in data" :key="index"
				@click="$router.push({path: '/activities-details',query: {id:item.id}})">
				<img class="activityImage" :src="item.img" />
				<div class="activityInfo">
					<div class="activityTitle ellipsis-1">{{item.title}}</div>
					<div class="activityTime">活动时间：{{item.action_time}} — {{item.end_time}}</div>
					<div class="activityEndTime">报名截止：{{item.last_time}}</div>
					<div class="activityPublishTime">发布时间：{{item.create_time}}</div>
				</div>
				<div class="status" v-if="item.status == '未开始'">
					<img class="statusBg" src="../assets/WonderfulActivities/iconC.png" />
					<span>未开始</span>
				</div>
				<img class="statusIcon" src="../assets/WonderfulActivities/iconA.png" v-if="item.status == '进行中'" />
				<img class="statusIcon" src="../assets/WonderfulActivities/iconB.png" v-if="item.status == '已截止'" />
			</div>
		</div>
		<PagePagination style="padding: .4rem 0 .8rem;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
	</div>
</template>

<script>
	export default {
		name: 'WonderfulActivities',
		data() {
			return {
				timeWhere: '',
				naviData: [{
					title: '全部活动',
					value: '',
				}, {
					title: '报名进行中',
					value: '1',
				}, {
					title: '报名已截止',
					value: '2',
				}],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				data: [],
			}
		},
		mounted() {
			this.activityList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.activityList()
			},
			changeTimeWhere(item) {
				this.timeWhere = item.value
				this.activityList()
			},
			activityList() {
				this.$api.post('/Activity/activity_list', {
					time_where: this.timeWhere,
					p: this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.popular-artists-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.menuBox {
		margin: .24rem 0 0;
		width: 12rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.naviBox {
			display: flex;
			align-items: center;

			.naviItem {
				margin-right: .24rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: .96rem;
				height: .4rem;
				background: #E29358;
				font-size: .16rem;
				text-align: center;
				line-height: .4rem;
				cursor: pointer;
			}

			.active {
				font-weight: 500;
				color: #252525;
				background: #E29358;
			}

			.normal {
				font-weight: 400;
				color: #000000;
				background: rgba(226, 147, 88, .3);
			}
		}
	}

	@media (max-width: 480px) {
		.activityList {
			margin: .12rem auto 0;
			width: 12rem;
			display: flex;
			flex-direction: column;

			.activity {
				margin-top: .12rem;
				display: flex;
				flex-direction: column;
				width: 11.86rem;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: .24rem;
				overflow: hidden;
				position: relative;
				cursor: pointer;

				.status {
					width: 1.32rem;
					height: .56rem;
					display: flex;
					align-items: center;
					position: absolute;
					right: 0;
					bottom: 1.44rem;

					.statusBg {
						position: absolute;
						width: 1.32rem;
						height: .56rem;
						right: 0;
						top: 0;
					}

					span {
						margin-left: .4rem;
						font-weight: 400;
						font-size: .24rem;
						color: #FFFFFF;
						z-index: 1;
					}
				}

				.statusIcon {
					position: absolute;
					width: 1.32rem;
					height: .56rem;
					right: 0;
					bottom: 1.44rem;
				}

				.activityImage {
					width: 11.86rem;
					height: 6rem;
					overflow: hidden;
					object-fit: cover;
				}

				.activityInfo {
					display: flex;
					flex-direction: column;
					padding: .28rem .32rem .56rem;

					.activityTitle {
						margin-bottom: .24rem;
						font-weight: 500;
						font-size: .32rem;
						color: #693200;
						line-height: .48rem;
					}

					.activityTime,
					.activityEndTime,
					.activityPublishTime {
						font-weight: 400;
						font-size: .24rem;
						color: #999999;
						line-height: .4rem;
					}
				}
			}
		}
	}

	@media (min-width: 481px) {
		.activityList {
			margin: .12rem auto 0;
			width: 12rem;
			display: flex;
			flex-wrap: wrap;

			.activity:nth-child(2n) {
				margin-right: 0;
			}

			.activity {
				margin-top: .12rem;
				margin-right: .14rem;
				display: flex;
				flex-direction: column;
				width: 5.93rem;
				background: #FFFFFF;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: .12rem;
				overflow: hidden;
				position: relative;
				cursor: pointer;

				.status {
					width: .66rem;
					height: .28rem;
					display: flex;
					align-items: center;
					position: absolute;
					right: 0;
					bottom: .72rem;

					.statusBg {
						position: absolute;
						width: .66rem;
						height: .28rem;
						right: 0;
						top: 0;
					}

					span {
						margin-left: .2rem;
						font-weight: 400;
						font-size: .12rem;
						color: #FFFFFF;
						z-index: 1;
					}
				}

				.statusIcon {
					position: absolute;
					width: .66rem;
					height: .28rem;
					right: 0;
					bottom: .72rem;
				}

				.activityImage {
					width: 5.93rem;
					height: 3rem;
					overflow: hidden;
					object-fit: cover;
				}

				.activityInfo {
					display: flex;
					flex-direction: column;
					padding: .14rem .16rem .28rem;

					.activityTitle {
						margin-bottom: .12rem;
						font-weight: 500;
						font-size: .16rem;
						color: #693200;
						line-height: .24rem;
					}

					.activityTime,
					.activityEndTime,
					.activityPublishTime {
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						line-height: .2rem;
					}
				}
			}
		}
	}
</style>